



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { queryDlDmUser, applyPermission, ifApplyPermission } from '@/api/project';

@Component({
  components: {}
})
class DocumentAuthApply extends Vue {
  @Prop()
  fileTypeId;

  @Prop()
  fileTypeName;

  dl: string = '';
  dm: string = '';
  type: number = 1;
  fileAuthType: number = 0;
  reason: string = '';
  isApplying: boolean = false;
  loading: boolean = false;

  mounted() {
    this.getifApplyPermission();
    // this.getDlDm();
  }

  @Watch('fileTypeId')
  fileTypeChange(value) {
    this.getifApplyPermission();
  }

  async getifApplyPermission() {
    try {
      let res = await ifApplyPermission({
        type: 2,
        companyId: this.$route.query.id,
        fileTypeId: this.fileTypeId
      });
      if (res.code === 200) {
        if (res.data) {
          this.isApplying = true;
        } else {
          this.isApplying = false;
          this.getDlDm();
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getDlDm() {
    try {
      let res = await queryDlDmUser({ id: this.$route.query.id });
      if (res.code === 200) {
        this.dl = res.data.dls[0].nickname;
        this.dm = res.data.dms.map(_ => _.nickname).join('、');
      }
    } catch (err) {
      console.log(err);
    }
  }

  typeChange(e) {
    this.type = e.target.value;
  }

  onChange(e) {
    this.fileAuthType = e.target.value;
  }

  async apply() {
    try {
      if (this.reason) {
        let data = {
          type: 2,
          // companyId: this.$route.query.id,
          fileTypeId: this.fileTypeId,
          fileAuthType: this.fileAuthType,
          reason: this.reason,
          companyId: this.type === 1 ? this.$route.query.id : ''
        };
        this.loading = true;
        let res = await applyPermission(data);
        this.loading = false;
        if (res.code === 200) {
          this.$message.success('申请成功');
          this.reason = '';
          this.getifApplyPermission();
        }
      } else {
        this.$message.error('请填写申请理由');
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }
}

export default DocumentAuthApply;
